module.exports = __webpack_public_path__ + "img/ic_r_forms@2x.8bd28cb0.png";